import { AxiosResponse } from 'axios';
import { useIntl } from 'react-intl';

import { ErrorCode, LocaleKeyFormatter } from './types';
import { ExpectedError } from '../../../types';
import type { LocalizedMessageId } from '../../../types';

export const defaultFormatter =
  (formatMessage: ReturnType<typeof useIntl>['formatMessage']) =>
  <T extends ErrorCode>(
    error: AxiosResponse<ExpectedError<T>>,
    toLocaleKey: LocaleKeyFormatter,
  ): string | string[] | undefined => {
    const { data } = error;

    // Multiple errors
    if (typeof data === 'object' && data !== null && 'errors' in data) {
      return data.errors.map((err) =>
        formatMessage({
          id: toLocaleKey(err.code || '').toLowerCase() as LocalizedMessageId,
          defaultMessage: err.message,
        }),
      );
    }

    if (data && data.message && data.message !== 'No message available') {
      return formatMessage({
        id: toLocaleKey(data.code || '').toLowerCase() as LocalizedMessageId,
        defaultMessage: data.message,
      });
    }
    return undefined;
  };
